<template>
	<LayoutList :nav="false" :has-fixed-group="true">
		<template slot="header">
			<h1>Select Recipients</h1>
			<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>
		</template>

		<form class="form" @submit.prevent="onSubmit">
			<GridMembers :selectable="true" :hideMergers="true" v-model="formData.members"></GridMembers>
			<div class="form__group form__group--submit-fixed">
				<button class="btn btn--primary" v-wait:disabled='["submit"]'>Send Opportunity</button>
			</div>
		</form>
	</LayoutList>
</template>

<script>
	import API from './../../api';
	import GridMembers from '../Grid/GridMembers';
	import LayoutList from '../Layout/LayoutList';
	import ValidationAlert from '../ValidationAlert';

	export default {
		name: 'OpportunityShare',
		components: {
			ValidationAlert,
			LayoutList,
			GridMembers,
		},
		props: {
			id: {
				type: Number,
				required: true,
			}
		},
		data() {
			return {
				formData: {
					members: [],
				},
			}
		},
		methods: {
			onSubmit() {
				this.$wait.start('submit');

				API.shareOpportunity(this.id, this.formData.members).then(response => {
					this.showModal();
				}).catch(error => {
					//TODO: Error handling
				}).finally(() => {
					this.$wait.end('submit');
				});
			},
			showModal() {
				this.$modal.show('dialog', {
					title: 'Thank you for the submission',
					text: 'An email has been sent to the selected recipients',
					buttons: [
						{
							title: 'View my opportunities',
							handler: () => {
								this.$router.push({
									name: 'opportunities',
									params: {
										tab: 'mine',
									},
								})
							},
						},
					],
				});
			},
		},
	}
</script>
